<template>
  <a-layout-header
    :class="[
      fixHeader && 'ant-header-fixedHeader',
      layout === 'side'
        ? sidebarOpened
          ? 'ant-header-side-opened'
          : 'ant-header-side-closed'
        : null,
      theme,
      'global-header',
    ]"
  >
    <div :class="['global-header-wide', layout]">
      <router-link
        v-if="isMobile || layout === 'side'"
        to="/"
        :class="['logo', isMobile ? null : 'pc', theme]"
      >
        <img src="static/img/logo.png" alt="" />
        <!-- <h1 v-if="!isMobile">{{ systemName }}</h1> -->
      </router-link>
      <a-divider v-if="isMobile" type="vertical" />
      <a-icon
        v-if="layout === 'head'"
        class="trigger"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        @click="toggleCollapse"
      />
      <!-- <div v-if="layout === 'head'" class="global-header-menu">
				<i-menu style="height: 64px; line-height: 64px;margin-left: 44px;" class="system-top-menu" :theme="theme" mode="horizontal" :menuData="menuData" @select="onSelect" />
			</div> -->

      <div v-if="layout === 'side'" class="global-header-menu">
        <i-menu
          style="height: 40px; line-height: 40px"
          class="system-top-menu"
          :theme="theme"
          mode="horizontal"
          :menuData="menuData"
          @select="onSelect"
        />
      </div>

      <div :class="['global-header-right', theme]">
        <header-avatar class="header-item" />
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import HeaderAvatar from "./HeaderAvatar";
import IMenu from "@/components/menu/menu";
import { mapState } from "vuex";

export default {
  name: "GlobalHeader",
  components: { IMenu, HeaderAvatar },
  props: ["collapsed", "menuData"],
  computed: {
    ...mapState({
      isMobile: (state) => state.setting.isMobile,
      layout: (state) => state.setting.layout,
      systemName: (state) => state.setting.systemName,
      sidebarOpened: (state) => state.setting.sidebar.opened,
      fixHeader: (state) => state.setting.fixHeader,
    }),
    theme() {
      return this.layout === "head" ? "light" : this.$store.state.setting.theme;
    },
  },
  data() {
    return {
      current: ["mail"],
    };
  },
  methods: {
    toggleCollapse() {
      this.$emit("toggleCollapse");
    },
    onSelect(obj) {
      this.$emit("menuSelect", obj);
    },
  },
};
</script>

<style lang="less" scoped>
.trigger {
  font-size: 20px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
.header-item {
  padding: 0 19px;
  display: inline-block;
  height: 100%;
  cursor: pointer;
  vertical-align: middle;
  i {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
  }
}
.global-header {
  padding: 0 12px 0 0;
  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  &.light {
    background: #fff;
    /deep/ .ant-menu-horizontal > .ant-menu-item {
      border-bottom: none;
      vertical-align: middle;
      padding: 0 24px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      margin-left: 10px;
      &.ant-menu-item-selected {
        background: rgba(33, 180, 135, 0.2);
        color: #21b487;
      }
      &:hover {
        background: rgba(33, 180, 135, 0.2);
        color: #21b487;
      }
    }
  }
  &.dark {
    background: #393e46;
  }
  .global-header-wide {
    &.head {
      //   padding: 0 24px;
    }
    &.side {
    }
    .logo {
      display: inline-block;
      vertical-align: top;
      width: 254px;
      height: 64px;
      background-color: #21b487;
      //   line-height: 58px;
      //   vertical-align: top;
      //   display: inline-block;
      //   padding: 0 12px 0 24px;
      cursor: pointer;
      //   font-size: 20px;
      //   &.pc {
      //     padding: 0 12px 0 0;
      //   }
      img {
        // display: inline-block;
        // vertical-align: top;
        display: block;
        width: 100%;
        height: 100%;
      }
      h1 {
        display: inline-block;
        font-size: 16px;
      }
      &.dark h1 {
        color: #fff;
      }
    }
    .global-header-menu {
      display: inline-block;
    }
    .global-header-right {
      float: right;
      &.dark {
        color: #fff;
        i {
          color: #fff;
        }
      }
    }
  }
}
.ant-header-fixedHeader {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 15;
  width: 100%;
  transition: width 0.2s;

  &.ant-header-side-opened {
    width: 100%;
    // padding-left: 254px;
  }

  &.ant-header-side-closed {
    width: 100%;
    padding-left: 80px;
  }
}
.global-header .global-header-wide .logo.pc {
  width: 254px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalHeader.vue